// src/components/MainContent.js
import React, { useEffect } from "react";
import AboutSection from "./main/AboutSection";
import HeroSection from "./main/HeroSection";
import WhyChooseUs2 from "./main/WhyChooseUs2.js";
import OurProducts from "./main/OurProducts.js";
import Testimonials from "./main/Testimonials.js";
import FAQCollapse from "./main/Faq.js";
import OrderFlow from "./main/OrderFlow.js";
import SpecialDeal from "./main/SpecialDeal.js";
import ContactSection from "./main/Contact.js";
import OurBrands from "./main/OurBrands.js";

const MainContent = () => {
  useEffect(() => {
    // Inisialisasi library JS seperti AOS, Swiper, GLightbox jika perlu
  }, []);

  return (
    <main className="main">
      {/* Hero Section sekarang ada di HeroHeader component */}
      <HeroSection />
      <AboutSection />
      <WhyChooseUs2 />
      <OrderFlow />
      <SpecialDeal />
      <OurBrands />
      <OurProducts />
      <Testimonials />
      <ContactSection />
      <FAQCollapse />
      {/* Tambahkan section lain di sini */}
    </main>
  );
};

export default MainContent;
